export const googleMaps = window.google.maps
export const MarkerClusterer = window.MarkerClusterer
export const jsonUrl = 'https://firebasestorage.googleapis.com/v0/b/business-map-274423.appspot.com/o/businesses.json?alt=media&token=5339ae55-0ee9-4012-a9b6-1399042b889b'

export const industries = [
  {value: 1, text: 'Agriculture'},
  {value: 2, text: 'Auto'},
  {value: 3, text: 'Construction'},
  {value: 4, text: 'Education'},
  {value: 5, text: 'Energy & Mining'},
  {value: 6, text: 'Entertainment & Arts'},
  {value: 7, text: 'Finance & Insurance'},
  {value: 8, text: 'Food & Drink'},
  {value: 9, text: 'Freelance'},
  {value: 10, text: 'Health'},
  {value: 11, text: 'Information/Media'},
  {value: 12, text: 'Leisure & Hospitality'},
  {value: 13, text: 'Manufacturing'},
  {value: 14, text: 'Personal services'},
  {value: 15, text: 'Professional/Business services'},
  {value: 16, text: 'Real estate'},
  {value: 17, text: 'Recreation & Fitness'},
  {value: 18, text: 'Retail'},
  {value: 19, text: 'Technology'},
  {value: 20, text: 'Transportation'},
  {value: 21, text: 'Other'}
]

export const issues = [
  {value: 0, text: 'Temporarily closed'},
  {value: 1, text: 'Critical drop in demand'},
  {value: 2, text: 'Unable to pay rent'},
  {value: 3, text: 'Unable to pay wages'},
  {value: 4, text: 'Unable to pay taxes'},
  {value: 5, text: 'Permanently closed'},
  {value: 6, text: 'Applied for aid/loans but still waiting'},
  {value: 7, text: 'Applied for aid/loans but rejected'},
  {value: 8, text: 'Unsure how to apply for aid/loans'},
  {value: 9, text: 'Other'}
]